var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortArrowDown = function SvgSortArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "9px",
    viewBox: "0 0 10 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.666667, 0.333333)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "4.56711429 7.96345714 0.103114286 0.1872 8.99022857 0.1872"
  }))));
};
export default SvgSortArrowDown;